import { Button } from 'antd';
import styled, { css } from 'styled-components';

import * as selfVars from './Header.styles.vars';

const sharedStyles = css({
  paddingInline: selfVars.paddingInline,
});

export const LogoContainer = styled.div(
  () => sharedStyles,
  ({ theme }) => ({
    background: `${theme.header.secondary.bg} 0% 0% no-repeat padding-box`,
    boxShadow: `0 3rem 6rem ${theme.header.secondary.border}`,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    height: selfVars.logoHeight,
  })
);

export const NavContainer = styled.header(
  () => sharedStyles,
  ({ theme }) => ({
    position: 'sticky',
    insetBlockStart: -1,
    zIndex: theme.overlayPosition.layerImportant,

    boxShadow: `0 3rem 6rem ${theme.header.secondary.border}`,
    backgroundColor: theme.header.primary.bg,
    height: selfVars.navHeight,
  })
);

export const LogoButton = styled.button({
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
});

export const Links = styled.div({
  display: 'flex',
  gap: '16rem',
});

export const Link = styled(Button)(({ theme }) => ({
  textDecoration: 'underline',
  fontSize: theme.typography.size14,
  fontFamily: theme.typography.family.arial,
  color: theme.header.secondary.text,
  textTransform: 'capitalize',
  background: 'none',
  border: 'none',
}));
